export const SUPPLIER_STATUS = {
  incomplete: "incomplete",
  sent: "sent",
  started: "started",
  complete: "complete",
};
